import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from 'hui/src/styled/theme';

//todo make this component/deduplicate??
const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const AnswerLabel = styled.label`
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid ${colors.GREY};
  border-radius: 100px;
  background-color: ${Theme.snow};
  color: ${colors.MEDIUM_DARK_GREY};
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  ${props =>
    props.stacked &&
    css`
      display: block;
    `};
`;

const Checkbox = styled(Field)`
  display: none;
`;

const CheckboxOption = styled.div`
  display: inline-block;
  margin: 0 5px 5px 0;
  ${props =>
    props.stacked &&
    css`
      display: block;
    `};

  input[type='checkbox']:checked + label {
    background: ${Theme.primary};
    color: ${Theme.snow};
    border-color: ${Theme.primary};
  }
`;

export default function CheckboxGroup({ options, name, label, stacked }) {
  return (
    <div>
      <QuestionLabel>{label}</QuestionLabel>

      {options.map(({ value, label }) => {
        const key = `${name}.${value}`;
        return (
          <CheckboxOption key={key} stacked={stacked}>
            <Checkbox
              type="checkbox"
              name={key}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return <input name={key} {...input} {...rest} />;
              }}
            />
            <AnswerLabel key={key} htmlFor={key} stacked={stacked}>
              {label}
            </AnswerLabel>
          </CheckboxOption>
        );
      })}
    </div>
  );
}

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  stacked: PropTypes.bool
};
